export default __webpack_public_path__ + "static/media/rain-2-night.fde7e34d.svg";